<template>
  <div>
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4 my-3">
        <div class="bg-white rounded border border-gray-200 overflow-hidden">
          <div class="bg-gray-50 px-3 py-2 font-semibold text-gray-700 border-b border-gray-200">
            Attachments
          </div>
          <div class="overflow-x-auto">
            <table class="w-full text-xs">
              <thead class="bg-gray-50">
                <tr>
                  <th class="text-left py-2 px-3 font-semibold text-gray-700 border-b border-gray-200">#</th>
                  <th class="text-left py-2 px-3 font-semibold text-gray-700 border-b border-gray-200">File Name</th>
                  <th class="text-center py-2 px-3 font-semibold text-gray-700 border-b border-gray-200">Status</th>
                  <th class="text-right py-2 px-3 font-semibold text-gray-700 border-b border-gray-200">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(file, idx) in attachments"
                  :key="idx"
                  class="hover:bg-gray-50 transition"
                >
                  <td class="py-2 px-3 border-b border-gray-200">{{ idx + 1 }}</td>
                  <td class="py-2 px-3 border-b border-gray-200 capitalize">
                    {{ cleanUnderscores(file.fileDescription) }}
                  </td>
                  <td class="py-2 px-3 border-b border-gray-200 text-center">
                    <i
                      :class="file.status === 'APPROVED' ? 'fa-solid fa-eye text-green-600' : 'fa-solid fa-eye-slash text-gray-400'"
                      style="cursor: pointer"
                    ></i>
                  </td>
                  <td class="py-2 px-3 border-b border-gray-200 text-right">
                    <button
                      @click="openFile(file)"
                      class="btn-primary bg-primary hover:bg-primary-700 text-white px-3 py-1 rounded text-xs font-medium transition"
                    >
                      Select file
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-span-8">
        <label class="block text-sm font-medium text-primary mb-2">{{ cleanUnderscores(attachmentType || "") }}</label>
        <InsolvencyAttachments ref="attachmentScreen" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import InsolvencyAttachments
  from "@/domains/home/services/configurations/views/settings/insolvency/InsolvencyAttachments.vue";
import { Attachment } from "@/domains/home/services/configurations/views/types";


const props = defineProps({
  attachments: Array<Attachment>,
})
const emit = defineEmits(['attachment'])

const attachmentUrl = ref<string | null>(null)
const attachmentType = ref<string | null>(null)
const attachmentId = ref<string | null>(null)
const attachments = ref<Attachment[]>([])
const attachmentScreen = ref<InstanceType<typeof InsolvencyAttachments> | null>(null)

const cleanUnderscores = (text: string) => {
  if (!text) return ''
  return text.replace(/_/g, ' ')
}

const openFile = (data: Attachment) => {
  if (data) {
    const fName = data.fileName ? data.fileName.trim() : ''
    attachmentUrl.value = import.meta.env.VITE_API_BASE_URL + '/insolvency/files?attachment=' + fName
    attachmentType.value = data.type.trim()
    emit('attachment', data)

    if (attachmentScreen.value) {
      attachmentScreen.value.openFile(attachmentUrl.value)
    }
  }
}

onMounted(() => {
  if (props.attachments && props.attachments.length > 0) {
    openFile(props.attachments[0])

    // Filter attachments that have fileDescription that starts with "newspaper" or "gazetted" (case-insensitive)
    const newspaper = props.attachments.filter((attachment) =>
      attachment.fileDescription.toLowerCase().startsWith('newspaper')
    )
    const gazetted = props.attachments.filter((attachment) =>
      attachment.fileDescription.toLowerCase().startsWith('gazetted')
    )

    // Merge the two arrays
    attachments.value = [...newspaper, ...gazetted]
  }
})
</script>
